// extracted by mini-css-extract-plugin
export default {"suggestionContainer":"Suggestions_suggestionContainer__z+MAV","icon":"Suggestions_icon__fhR3j","suggestionButton":"Suggestions_suggestionButton__caMmQ"};